import { googleAnalytics } from '../Services/googleAnalytics';

export const CONFIG_CLOSE = 'CONFIG_CLOSE';
export const CONFIG_OPEN = 'CONFIG_OPEN';
export const CONFIG_LOAD = 'CONFIG_LOAD';
export const CONFIG_TAB = 'CONFIG_TAB';
export const CONFIG_PRODUCT_SERVICE_TAB = 'CONFIG_PRODUCT_SERVICE_TAB';
export const CONFIG_CHANGE_SETTING = 'CONFIG_CHANGE_SETTING';
export const PRODUCT_QUANTITY_SET_TOTAL_WEIGHT = 'PRODUCT_QUANTITY_SET_TOTAL_WEIGHT';
export const PRODUCT_QUANTITY_SET_UNIT = 'PRODUCT_QUANTITY_SET_UNIT';
export const PRODUCT_QUANTITY_SET_BASE_QUANTITY = 'PRODUCT_QUANTITY_SET_BASE_QUANTITY';
export const DELIVERY_CONFIG_SET = 'DELIVERY_CONFIG_SET';
export const CONFIGURATOR_SET = 'CONFIGURATOR_SET';
export const CONFIG_SELECTION_CUTTING_DETAILS_ADD = 'CONFIG_SELECTION_CUTTING_DETAILS_ADD';
export const CONFIG_SELECTION_CUTTING_DETAILS_DELETE = 'CONFIG_SELECTION_CUTTING_DETAILS_DELETE';
export const CONFIG_SELECTION_CUTTING_DETAILS_UPDATE = 'CONFIG_SELECTION_CUTTING_DETAILS_UPDATE';
export const SET_SALE_QUANTITY = 'SET_SALE_QUANTITY';
export const CONFIG_SELECTION_COIL_DETAILS_ADD = 'CONFIG_SELECTION_COIL_DETAILS_ADD';
export const CONFIG_SELECTION_COIL_DETAILS_DELETE = 'CONFIG_SELECTION_COIL_DETAILS_DELETE';
export const CONFIG_SELECTION_COIL_DETAILS_UPDATE = 'CONFIG_SELECTION_COIL_DETAILS_UPDATE';

export const ADD_RECOMMENDED_PRODUCT = 'ADD_RECOMMENDED_PRODUCT';
export const REMOVE_RECOMMENDED_PRODUCT = 'REMOVE_RECOMMENDED_PRODUCT';
export const UPDATE_RECOMMENDED_PRODUCT_QUANTITY = 'UPDATE_RECOMMENDED_PRODUCT_QUANTITY';


export const close = () => ({
  type: CONFIG_CLOSE,
});

export const changeTab = (number) => ({
  type: CONFIG_TAB,
  payload: number,
});

export const changeSetting = (data) => ({
  type: CONFIG_CHANGE_SETTING,
  payload: data,
});

export const open = ({ id, orderRow, isConfigurable, isStandAlone = false }) => ({
  type: CONFIG_OPEN,
  payload: {
    id: id,
    orderRow: orderRow,
    isConfigurable: isConfigurable,
    isStandAlone: isStandAlone
  },
});

export const load = (data) => ({
  type: CONFIG_LOAD,
  payload: data,
});

export const setTotalWeight = (data) => ({
  type: PRODUCT_QUANTITY_SET_TOTAL_WEIGHT,
  payload: { totalWeight: data },
});

export const setUnit = (data) => ({
  type: PRODUCT_QUANTITY_SET_UNIT,
  payload: { selectedUnit: data },
});

export const setBaseUnitQuantity = (data) => ({
  type: PRODUCT_QUANTITY_SET_BASE_QUANTITY,
  payload: { baseUnitQuantity: data },
});

export const setDeliveryDetailsValues = (value) => ({
  type: DELIVERY_CONFIG_SET,
  payload: value,
});

export const changeProductServiceTab = (number) => ({
  type: CONFIG_PRODUCT_SERVICE_TAB,
  payload: number,
});

export const setValues = (value) => ({
  type: CONFIGURATOR_SET,
  payload: value,
});

export const setEmptyCuttingDetails = () => ({
  type: CONFIG_SELECTION_CUTTING_DETAILS_ADD,
});

export const deleteCuttingDetails = (id) => ({
  type: CONFIG_SELECTION_CUTTING_DETAILS_DELETE,
  payload: id,
});

export const setCuttingDetails = (id, field, value) => ({
  type: CONFIG_SELECTION_CUTTING_DETAILS_UPDATE,
  payload: { id, field, value },
});

export const setSalesQuantity = (data) => ({
  type: SET_SALE_QUANTITY,
  payload: { salesQuantity: data },
});

export const setEmptyCoilDetails = () => ({
  type: CONFIG_SELECTION_COIL_DETAILS_ADD,
});

export const deleteCoilDetails = (id) => ({
  type: CONFIG_SELECTION_COIL_DETAILS_DELETE,
  payload: id,
});

export const setCoilDetails = (id, field, value) => ({
  type: CONFIG_SELECTION_COIL_DETAILS_UPDATE,
  payload: { id, field, value },
});


export const renderProductGoogleAnalytics = (product) => {
  googleAnalytics({
    event: 'product-view',
    ecommerce: {
      detail: {
        products: [
          {
            name: product.articleName,
            id: product.id,
            category: product.breadcrumbs,
            campaignProduct: product.isCampaignProduct,
          },
        ],
      },
    },
  }
  )
};

export const addRecommendedProduct = (articleNumber, salesQuantity,selectedUnit) => ({
  type: ADD_RECOMMENDED_PRODUCT,
  payload: { articleNumber, quantity:salesQuantity,salesQuantity,selectedUnit },
});

export const removeRecommendedProduct = (articleNumber) => ({
  type: REMOVE_RECOMMENDED_PRODUCT,
  payload: articleNumber,
});

export const updateRecommendedProductQuantity = (articleNumber, salesQuantity) => ({
  type: UPDATE_RECOMMENDED_PRODUCT_QUANTITY,
  payload: { articleNumber, salesQuantity },
});
